exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3UUra69ZKPmwt1PZzoY85k{background:#f3f5f7;border-bottom:.07143rem solid #ccc;padding:0}.N60pGYS7oFWQ832jDooPc{height:10.71429rem;width:10.71429rem}.aaBaOK5rretB1MnYZGTC6{color:#4a4a4a;font-size:125%;font-weight:600;letter-spacing:.07143rem;margin-bottom:.14286rem;padding:0;text-align:center}", ""]);

// exports
exports.locals = {
	"colorSideNav": "#008a8a",
	"StudentHorizontalSelect": "_3UUra69ZKPmwt1PZzoY85k",
	"StudentHorizontalSelect_options": "N60pGYS7oFWQ832jDooPc",
	"StudentHorizontalSelect_options_score": "aaBaOK5rretB1MnYZGTC6"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"root":".","modules":true,"import":false,"importLoaders":1}!../node_modules/postcss-loader/lib?{"config":{"path":"/var/lib/jenkins/workspace/_omni-operation-ui_release_2.7.2/node_modules/omni-common-ui/postcss.config.js"}}!./containers/Group/ProgressTest/StudentHorizontalSelect/style.postcss
// module id = 1450
// module chunks = 0